module.exports = __webpack_public_path__ + "img/bg_room_manage_apply.66ce05fd.png";